module.exports = __webpack_public_path__ + "img/shuangLED.34aae02f.png";